(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["phosei-bazi-consultation-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-consultation-product]');
    if (!root) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealTargets = root.querySelectorAll('.pbc-hero__copy, .pbc-chart, .pbc-copy-split, .pbc-natal, .pbc-heading, .pbc-reveals__grid article, .pbc-process__list, .pbc-process__list li, .pbc-values article, .pbc-stats__grid > div, .pbc-plan, .pbc-faq__list details, .pbc-testimonials__grid article, .pbc-panel');
    revealTargets.forEach((element, index) => {
      element.setAttribute('data-pbc-reveal', '');
      element.style.setProperty('--pbc-delay', `${Math.min(index % 6, 5) * 55}ms`);
    });
    if (!reduceMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-pbc-visible', '');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealTargets.forEach((element) => observer.observe(element));
    } else {
      revealTargets.forEach((element) => element.setAttribute('data-pbc-visible', ''));
    }
    const chart = root.querySelector('.pbc-chart');
    if (chart && window.matchMedia('(pointer: fine)').matches && !reduceMotion) {
      chart.addEventListener('pointermove', (event) => {
        const bounds = chart.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        chart.style.setProperty('--tilt-x', `${(-y * 5).toFixed(2)}deg`);
        chart.style.setProperty('--tilt-y', `${(x * 6).toFixed(2)}deg`);
        root.style.setProperty('--pbc-glow-x', `${Math.round((event.clientX / window.innerWidth) * 100)}%`);
        root.style.setProperty('--pbc-glow-y', `${Math.round((event.clientY / window.innerHeight) * 100)}%`);
      });
      chart.addEventListener('pointerleave', () => {
        chart.style.setProperty('--tilt-x', '0deg');
        chart.style.setProperty('--tilt-y', '0deg');
      });
    }
    const testimonialTrack = root.querySelector('.pbc-testimonials__grid');
    const previousTestimonial = root.querySelector('[data-testimonial-previous]');
    const nextTestimonial = root.querySelector('[data-testimonial-next]');
    const moveTestimonials = (direction) => {
      if (!testimonialTrack) return;
      const card = testimonialTrack.querySelector('article');
      if (!card) return;
      const gap = Number.parseFloat(window.getComputedStyle(testimonialTrack).columnGap) || 22;
      testimonialTrack.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    previousTestimonial?.addEventListener('click', () => moveTestimonials(-1));
    nextTestimonial?.addEventListener('click', () => moveTestimonials(1));
    const updateTestimonialControls = () => {
      if (!testimonialTrack) return;
      const maxScroll = Math.max(0, testimonialTrack.scrollWidth - testimonialTrack.clientWidth);
      if (previousTestimonial) previousTestimonial.disabled = testimonialTrack.scrollLeft <= 3;
      if (nextTestimonial) nextTestimonial.disabled = testimonialTrack.scrollLeft >= maxScroll - 3;
    };
    testimonialTrack?.addEventListener('scroll', updateTestimonialControls, { passive: true });
    window.addEventListener('resize', updateTestimonialControls, { passive: true });
    updateTestimonialControls();
    root.querySelectorAll('[data-buy-now-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const error = form.querySelector('[data-buy-error]');
        if (!button || button.disabled) return;
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'ADDING...';
        error.textContent = '';
        try {
          const response = await fetch(form.dataset.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign(root.dataset.checkoutUrl);
        } catch (requestError) {
          error.textContent = 'We could not open checkout. Please try again.';
          button.disabled = false;
          button.innerHTML = original;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
